/* eslint-disable no-underscore-dangle */
import { CONFIG } from '../config';

class BfvInputHandler {
  constructor(options = {}) {
    this.$root = options.element;
    this.$input = this.$root.querySelector('input');
    this.delayToTrigger = 400;
  }

  init() {
    this.__bindEvents();
  }

  __bindEvents() {
    // on change of input and delay
    let delayTimer;
    this.$input.addEventListener('input', (evt) => {
      const $eventTarget = this.$input;
      const maxLength = Number(evt.target.getAttribute('maxlength'));
      const value = maxLength ? evt.target.value.slice(0, maxLength) : evt.target.value;

      clearTimeout(delayTimer);
      if ((evt.target.value + 1) > maxLength) {
        this.$input.value = value;
      }

      const event = document.createEvent('CustomEvent');

      event.initCustomEvent(
        CONFIG.events.BFV_TEXTINPUT_CHANGED,
        false,
        false,
        {
          value,
        });


      delayTimer = setTimeout(() => {

        if ($eventTarget) {
          $eventTarget.dispatchEvent(event);
        }
      }, this.delayToTrigger);
    });

    this.$root.addEventListener(CONFIG.events.BFV_RESET_FILTER, () => {
      this.$input.value = '';
    });
  }
}

export default BfvInputHandler;



// WEBPACK FOOTER //
// ./src/javascript/main/BfvInputHandler/index.js